import { TableTitle } from '@lmt/unicorn-shared/app/components/common/table/TableTitle';
import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useInsertKeyHandler } from '@lmt/unicorn-shared/app/components/dictionaries/useInsertKeyHandler';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC, useCallback } from 'react';
import { RolesTable } from './components/RolesTable';

import tableStyles from '@lmt/unicorn-shared/app/components/common/table/TableTitle.module.scss';
import AddIcon from '@lmt/unicorn-shared/app/icons/plus-blue.svg?react';
import { useRoles } from '@lmt/unicorn-shared/app/features/roles/selectors';
import { useModal } from '../../common/ui-kit/modal/useModal';
import { QueryFactory } from '@lmt/shared-types';

export const RoleList: FC = () => {
  const i18next = useScopedTranslation('roles.list');
  const forms = useGlobalForms();
  const roles = useRoles();
  const modals = useModal();

  const removeRole = useCallback(async (roleId: number) => {
    const isConfirmed = await modals.showConfirm({
      text: i18next.t('confirmation_remove_role'),
    });
    if (isConfirmed) {
      try {
        await QueryFactory.RoleClient.removeRole(roleId);
      } catch (error) {
        await modals.showError({ text: i18next.t('error_remove_role') });
      }
    }
  }, []);

  useInsertKeyHandler(forms.openRoleCreating);

  return (
    <div
      className={tableStyles.pageContainer}
      data-test-id="table-page-container"
    >
      <div className={tableStyles.tableToolbar}>
        <TableTitle title={i18next.t('title')} count={roles.length} />
        <Button
          title={i18next.t('add_button')}
          color={ButtonColor.Primary}
          onClick={forms.openRoleCreating}
          iconComponent={<AddIcon />}
          testId={'plus-button'}
        />
      </div>
      <div className={tableStyles.tableContainer}>
        <RolesTable
          data={roles}
          noResults={false}
          onDelete={removeRole}
          onEdit={forms.openRoleEditing}
        />
      </div>
    </div>
  );
};
